import { Typography, Stack, Container, Box, Card, Autocomplete, Checkbox, TextField } from "@mui/material";
import CardContent from "@mui/material/CardContent";
import React, { useEffect, useState } from "react";
import MuiDataTable from "../../components/muidatatable";
import MuiSearch from "../../components/muisearch";
import MuiButton from "../../components/muibutton";
import { getAPI, getAPIwithParams } from "../../services/basehttpAPI";
import { useLocation, useNavigate } from "react-router-dom";
import * as BusinessConst from "../../utils/businessconstants";
import SnackbarComponent from "../../components/snackbar";

const UserList = () => {
  const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
  //always pass id, label, align property
  const columnHeaders = [
    { id: "id", label: "#", align: "left", enableSort: true },
    {
      id: "fullName",
      label: translatedText?.name,
      align: "left",
      enableSort: true,
      style: "bold",
    },
    { id: "email", label: translatedText?.email, align: "left", enableSort: true },
    { id: "isActive", label: translatedText?.status, align: "left", enableSort: true },
    { id: "lastLogin", label: translatedText?.last_login, align: "left", enableSort: true },
    { id: "action", label: translatedText?.action, align: "left", pagekey: BusinessConst.pagekey_userlist, enableSort: false },
  ];
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState([]);
  const [dataList, setDataList] = useState([]);
  const [baseFilteredData, setBaseFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState(() => sessionStorage.getItem("userlist_SearchKeyword") || "");

  const [open, setOpen] = useState(false);
  const [message, setmessage] = useState(null);
  const [severity, setseverity] = useState(null);
  const location = useLocation();

  const [customerProfileList, setCustomerProfileList] = useState([]);
  const [selectedCustomersList, setSelectedCustomersList] = useState(
    () => JSON.parse(sessionStorage.getItem("userlist_selectedCustomers")) || []
  );
  const [userShipToPartyList, setuserShipToPartyList] = useState([]);
  const [selectedUserShipToPartyList, setSelectedUserShipToPartyList] = useState(
    () => JSON.parse(sessionStorage.getItem("userlist_selectedShipToList")) || []
  );
  const [selectedUserShipToPartyDisplay, setselectedUserShipToPartyDisplay] = useState(
    () => JSON.parse(sessionStorage.getItem("userlist_selectedShipToDisplay")) || []
  );
  const [IsAllSelected, setIsAllSelected] = useState(false);

  const [UsersUnderSelectedCustomers, setUsersUnderSelectedCustomers] = useState([]);
  const [UsersUnderSelectedShipToParty, setUsersUnderSelectedShipToParty] = useState([]);


  const getAllApplicationUsers = async () => {
    let url = "ApplicationUser/GetApplicationUserByMarketId";
    const response = await getAPI(url, null);
    setInitialData(response.responseData);
  };

  const getAllCustomerProfiles = async () => {
    let url = "CustomerProfile/GetAllCustomerProfile";
    const response = await getAPI(url, null);
    const profileList = response.responseData;
    let newDataList = [];
    profileList?.map((obj) => {
      let newData = { id: obj.id, name: obj.customerName };
      newDataList.push(newData);
      return newData;
    });
    setCustomerProfileList(newDataList);
  };

  const getUserShipToPartyDetails = async () => {
    let url = "CustomerProfile/GetUserShipToPartyByUserId";
    const userModel = { userId: null };
    const response = await getAPIwithParams(url, userModel);
    let newDataList = [];
    response?.map((obj, index) => {
      let newData = {
        id: index + "_" + (obj.customShipToPartyName || obj.shipToPartyName),
        name: (obj.customShipToPartyName || obj.shipToPartyName),
        shipToId: obj.shipToId,
        customerProfileId: obj.customerProfileId,
        customerShiptoPartyId: obj.customerShiptoPartyId,
      };
      newDataList.push(newData);
      return newData;
    });
    setuserShipToPartyList(newDataList);
  };

  useEffect(() => {
    getAllApplicationUsers();
    getAllCustomerProfiles();
    getUserShipToPartyDetails();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (location.state?.Snackbaropen) {
      setseverity("success");
      setmessage("User Deleted successfully");
      setOpen(true);
      navigate({
        state: {
          Snackbaropen: false,
        }
      });
    }
  }, [location.state]);

  useEffect(() => {
    if (selectedCustomersList.length === 0) {
      setBaseFilteredData(initialData);
    }
  }, [initialData]);

  useEffect(() => {
    const filteredList = filterData(searchValue, baseFilteredData);
    setDataList(filteredList);
    sessionStorage.setItem("userlist_SearchKeyword", searchValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue, baseFilteredData]);

  useEffect(() => {
    sessionStorage.setItem("userlist_selectedCustomers", JSON.stringify(selectedCustomersList));
    sessionStorage.setItem("userlist_selectedShipToList", JSON.stringify(selectedUserShipToPartyList));
    sessionStorage.setItem("userlist_selectedShipToDisplay", JSON.stringify(selectedUserShipToPartyDisplay));
  }, [selectedCustomersList, selectedUserShipToPartyList, selectedUserShipToPartyDisplay]);

  useEffect(() => {
    if (initialData.length && userShipToPartyList.length && customerProfileList.length && selectedCustomersList.length) {
      const restoredCustomers = customerProfileList.filter((c) => selectedCustomersList.includes(c.id));
      handleCustomerChange(restoredCustomers);
    }
  }, [initialData, userShipToPartyList, customerProfileList]);


  const filterData = (searchValue, baseData) => {
    if (searchValue === "") {
      return baseData;
    }
    return baseData.filter(
      (d) =>
        d.firstName.toLowerCase().includes(searchValue.toLowerCase()) ||
        d.email.toLowerCase().includes(searchValue.toLowerCase()) ||
        (d.isActive ? "active" : "inactive").includes(searchValue.toLowerCase())
    );
  };

  const handleNavigation = () => {
    navigate("/layout/adduser");
  }

  const handleCustomerChange = (values) => {
    const customerIds = values.map((x) => x.id);
    const validEntries = selectedUserShipToPartyDisplay.filter((x) =>
      customerIds.includes(x.customerProfileId)
    );
    setselectedUserShipToPartyDisplay(validEntries);
    setSelectedUserShipToPartyList(validEntries.map((y) => y.id));
    setSelectedCustomersList(customerIds);
    setIsAllSelected(false);
    if (customerIds.length === 0) {
      setBaseFilteredData(initialData);
    } else {
      const usersUnderCustomers = initialData.filter((user) =>
        customerIds.some((customerId) =>
          user.userCustomerProfile?.some((z) => z.customerProfileId === customerId)
        )
      );
      setUsersUnderSelectedCustomers(usersUnderCustomers);
      if (validEntries.length > 0) {
        const filtered = usersUnderCustomers.filter((user) =>
          user.userShipToParty?.some((y) =>
            validEntries.some((z) => z.customerShiptoPartyId === y.customerShiptoPartyId)
          )
        );
        setBaseFilteredData(filtered);
      } else {
        setBaseFilteredData(usersUnderCustomers);
      }
    }
  };

  const handleUserShipToPartyChange = (values) => {
    const IsSelectAllPresent = values.some((x) => x.shipToId === "SelectAllShipToID");
    const OtherItems = values.filter((x) => x.shipToId !== "SelectAllShipToID");
    let effectiveValues;
    if (IsSelectAllPresent && !IsAllSelected) {
      setIsAllSelected(true);
      let Shiptopartyitems = FetchShipToPartyList();
      const combined = [...OtherItems, ...Shiptopartyitems];
      setselectedUserShipToPartyDisplay(combined);
      setSelectedUserShipToPartyList(combined.map((x) => x.id));
      effectiveValues = combined;
    } else {
      setIsAllSelected(false);
      setselectedUserShipToPartyDisplay(OtherItems);
      setSelectedUserShipToPartyList(OtherItems.map((x) => x.id));
      const AllOptions = userShipToPartyList.filter((x) =>
        selectedCustomersList.some((z) => z === x.customerProfileId)
      );
      if (AllOptions.length === OtherItems.length) {
        setIsAllSelected(true);
      }
      effectiveValues = OtherItems;
    }
    if (effectiveValues.length === 0) {
      setBaseFilteredData(UsersUnderSelectedCustomers);
    } else {
      const filtered = UsersUnderSelectedCustomers.filter((user) =>
        user.userShipToParty?.some((y) =>
          effectiveValues.some((z) => z.customerShiptoPartyId === y.customerShiptoPartyId)
        )
      );
      setBaseFilteredData(filtered);
    }
  };

  const FetchCustomerList = () => {
    return customerProfileList;
  };

  const FetchSelectedCustomers = () => {
    return customerProfileList.filter((x) => selectedCustomersList.includes(x.id));
  };

  const FetchShipToPartyList = () => {
    return userShipToPartyList.filter(
      (x) =>
        !selectedUserShipToPartyList.some((y) => y === x.id) &&
        selectedCustomersList.some((z) => z === x.customerProfileId)
    );
  };

  const FilterAutoCompleteOptions = (options, { inputValue }) => {
    const OptionList = options.filter(
      (item) =>
        item.name.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase()) ||
        item.shipToId.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())
    );
    if (options.length !== 0) {
      return [{ name: "Select All", shipToId: "SelectAllShipToID" }, ...OptionList];
    }
    return [...OptionList];
  };

  const FilterAutoCompleteCustomerOptions = (options, { inputValue }) => {
    return options.filter((item) =>
      item.name.toLocaleLowerCase().includes(inputValue.toLocaleLowerCase())
    );
  };




  return dataList?.length > 0 ? (
    <>
      <Container maxWidth="xl" sx={{ width: "100%", ml: "10px" }}>
        <Stack direction="row" spacing={2} alignItems="center" paddingBottom={"20px"}>
          <Typography variant="h5" flexGrow={1}>
            {" "}
            Users
          </Typography>

          <MuiButton
            type="button"
            text={translatedText.add_user}//"Add User"
            color="success"
            onClick={handleNavigation}
            show={true}
          />
        </Stack>
        {/*<Stack direction="row" spacing={2} alignItems="flex-start" paddingBottom={"30px"}>*/}
        {/*  <Autocomplete*/}
        {/*    multiple*/}
        {/*    filterSelectedOptions*/}
        {/*    sx={{ minWidth: 250 }}*/}
        {/*    options={FetchCustomerList()}*/}
        {/*    getOptionKey={(option) => option.id}*/}
        {/*    getOptionLabel={(option) => option.name}*/}
        {/*    value={FetchSelectedCustomers()}*/}
        {/*    isOptionEqualToValue={(option, value) => option.id === value.id}*/}
        {/*    onChange={(e, values) => handleCustomerChange(values)}*/}
        {/*    filterOptions={FilterAutoCompleteCustomerOptions}*/}
        {/*    renderInput={(data) => (*/}
        {/*      <TextField {...data} label="Select Customers" variant="outlined" />*/}
        {/*    )}*/}
        {/*  />*/}

        {/*  <Autocomplete*/}
        {/*    multiple*/}
        {/*    filterSelectedOptions*/}
        {/*    sx={{ minWidth: 250 }}*/}
        {/*    options={FetchShipToPartyList()}*/}
        {/*    getOptionLabel={(option) => `${option.name}  (${option.shipToId})`}*/}
        {/*    getOptionKey={(option) => option.customerShiptoPartyId}*/}
        {/*    isOptionEqualToValue={(option, value) => option.customerShiptoPartyId === value.customerShiptoPartyId}*/}
        {/*    onChange={(e, values) => handleUserShipToPartyChange(values)}*/}
        {/*    filterOptions={FilterAutoCompleteOptions}*/}
        {/*    value={selectedUserShipToPartyDisplay}*/}
        {/*    renderOption={(props, option, { selected }) => {*/}
        {/*      const { key, ...rest } = props;*/}
        {/*      return (*/}
        {/*        <li key={key} {...rest}>*/}
        {/*          <Checkbox style={{ marginRight: 8 }} checked={selected} />*/}
        {/*          <div>*/}
        {/*            {option.name}*/}
        {/*            {option.shipToId !== "SelectAllShipToID" && (*/}
        {/*              <>*/}
        {/*                <br />*/}
        {/*                <span style={{ fontSize: "12px", color: "gray" }}>{option.shipToId}</span>*/}
        {/*              </>*/}
        {/*            )}*/}
        {/*          </div>*/}
        {/*        </li>*/}
        {/*      );*/}
        {/*    }}*/}
        {/*    renderInput={(data) => (*/}
        {/*      <TextField {...data} label="Select Ship to party" variant="outlined" />*/}
        {/*    )}*/}
        {/*  />*/}
        {/*</Stack>*/}
        <Box>
          <MuiSearch callback={(searchValue) => setSearchValue(searchValue)} initialValue={searchValue} />
          <MuiDataTable headerdata={columnHeaders} rowData={dataList} storageKey="userlist" searchValue={searchValue} />
        </Box>
      </Container>
      <SnackbarComponent
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </>
  ) : (<>
    <Container maxWidth="xl" sx={{ width: "100%", ml: "10px" }}>
      <Stack direction="row" spacing={2} alignItems="center" paddingBottom={"20px"}>
        <Typography variant="h5" flexGrow={1}>
          {" "}
          Users
        </Typography>

        <MuiButton
          type="button"
          text={translatedText.add_user}//"Add User"
          color="success"
          onClick={handleNavigation}
          show={true}
        />
      </Stack>
      {/*<Stack direction="row" spacing={2} alignItems="flex-start" paddingBottom={"30px"}>*/}
      {/*  <Autocomplete*/}
      {/*    multiple*/}
      {/*    filterSelectedOptions*/}
      {/*    sx={{ minWidth: 250 }}*/}
      {/*    options={FetchCustomerList()}*/}
      {/*    getOptionKey={(option) => option.id}*/}
      {/*    getOptionLabel={(option) => option.name}*/}
      {/*    value={FetchSelectedCustomers()}*/}
      {/*    isOptionEqualToValue={(option, value) => option.id === value.id}*/}
      {/*    onChange={(e, values) => handleCustomerChange(values)}*/}
      {/*    filterOptions={FilterAutoCompleteCustomerOptions}*/}
      {/*    renderInput={(data) => (*/}
      {/*      <TextField {...data} label="Select Customers" variant="outlined" />*/}
      {/*    )}*/}
      {/*  />*/}

      {/*  <Autocomplete*/}
      {/*    multiple*/}
      {/*    filterSelectedOptions*/}
      {/*    sx={{ minWidth: 250 }}*/}
      {/*    options={FetchShipToPartyList()}*/}
      {/*    getOptionLabel={(option) => `${option.name}  (${option.shipToId})`}*/}
      {/*    getOptionKey={(option) => option.customerShiptoPartyId}*/}
      {/*    isOptionEqualToValue={(option, value) => option.customerShiptoPartyId === value.customerShiptoPartyId}*/}
      {/*    onChange={(e, values) => handleUserShipToPartyChange(values)}*/}
      {/*    filterOptions={FilterAutoCompleteOptions}*/}
      {/*    value={selectedUserShipToPartyDisplay}*/}
      {/*    renderOption={(props, option, { selected }) => {*/}
      {/*      const { key, ...rest } = props;*/}
      {/*      return (*/}
      {/*        <li key={key} {...rest}>*/}
      {/*          <Checkbox style={{ marginRight: 8 }} checked={selected} />*/}
      {/*          <div>*/}
      {/*            {option.name}*/}
      {/*            {option.shipToId !== "SelectAllShipToID" && (*/}
      {/*              <>*/}
      {/*                <br />*/}
      {/*                <span style={{ fontSize: "12px", color: "gray" }}>{option.shipToId}</span>*/}
      {/*              </>*/}
      {/*            )}*/}
      {/*          </div>*/}
      {/*        </li>*/}
      {/*      );*/}
      {/*    }}*/}
      {/*    renderInput={(data) => (*/}
      {/*      <TextField {...data} label="Select Ship to party" variant="outlined" />*/}
      {/*    )}*/}
      {/*  />*/}
      {/*</Stack>*/}
      <Box>
        <MuiSearch callback={(searchValue) => setSearchValue(searchValue)} initialValue={searchValue} />
      </Box>
      <Card>
        <CardContent>
          <Typography variant="h6" align="center" component="div">
            {translatedText?.no_records_found}
          </Typography>
        </CardContent>
      </Card>
    </Container>
  </>);
};

export default UserList;